const PASSWORD_GATE_STORAGE_PREFIX = 'muulti_password_gate_unlock:';

function normalizePassword(value) {
    return String(value ?? '');
}

function resolveGateTargetId(gate, fallbackTargetId = '') {
    // Use the actual panel ID before saved targets, which may still contain a shared draft ID.
    const componentId = String(fallbackTargetId ?? '').trim();
    if (componentId) return componentId;

    const fromGate = String(
        gate?.targetId ||
        gate?.componentId ||
        gate?.id ||
        ''
    ).trim();
    if (fromGate) return fromGate;
    return '';
}

export function getPasswordGateStorageKey(gate, fallbackTargetId = '') {
    const targetId = resolveGateTargetId(gate, fallbackTargetId);
    if (!targetId) return '';
    return `${PASSWORD_GATE_STORAGE_PREFIX}${targetId}`;
}

export function getPasswordGateAccessSource(gate, fallbackTargetId = '') {
    const configuredPassword = normalizePassword(gate?.password);
    if (!configuredPassword) return null;

    const storageKey = getPasswordGateStorageKey(gate, fallbackTargetId);
    if (!storageKey) return null;

    try {
        const sessionValue = sessionStorage.getItem(storageKey);
        const localValue = localStorage.getItem(storageKey);
        if (localValue === configuredPassword) return 'browser';
        if (sessionValue === configuredPassword) return 'session';
        return null;
    } catch {
        return null;
    }
}

export function hasPasswordGateAccess(gate, fallbackTargetId = '') {
    return getPasswordGateAccessSource(gate, fallbackTargetId) !== null;
}

export function unlockPasswordGate(gate, enteredPassword, fallbackTargetId = '') {
    const configuredPassword = normalizePassword(gate?.password);
    if (!configuredPassword) return false;
    if (normalizePassword(enteredPassword) !== configuredPassword) return false;

    const storageKey = getPasswordGateStorageKey(gate, fallbackTargetId);
    if (!storageKey) return false;

    try {
        sessionStorage.setItem(storageKey, configuredPassword);
    } catch {}
    try {
        localStorage.setItem(storageKey, configuredPassword);
    } catch {}

    return true;
}

// Clear this panel's remembered proof, preserving its configured password.
export function clearPasswordGateAccess(gate, fallbackTargetId = '') {
    const storageKey = getPasswordGateStorageKey(gate, fallbackTargetId);
    if (!storageKey) return false;
    let cleared = true;
    try { sessionStorage.removeItem(storageKey); } catch { cleared = false; }
    try { localStorage.removeItem(storageKey); } catch { cleared = false; }
    return cleared;
}
